import Doorphone from '@/services/api/doorphone';

export default {
  namespaced: true,
  state: {
    jobs: [],
    activeJobs: [],
    loading: false,
    pollTimer: null,
  },
  getters: {
    jobs: state => state.jobs,
    activeJobs: state => state.activeJobs,
    hasActiveJob: state => state.activeJobs.length > 0,
    queuedJobsCount: state => state.activeJobs.filter(j => j.status === 'queued').length,
    runningJobsCount: state => state.activeJobs.filter(j => j.status === 'running').length,
    queuedJobs: state => state.activeJobs.filter(j => j.status === 'queued'),
    loading: state => state.loading,
  },
  mutations: {
    setJobs (state, jobs) {
      state.jobs = jobs || [];
    },
    setActiveJobs (state, jobs) {
      state.activeJobs = jobs || [];
    },
    setLoading (state, loading) {
      state.loading = loading;
    },
    setPollTimer (state, timer) {
      state.pollTimer = timer;
    },
  },
  actions: {
    fetchJobs ({ commit }, { active = false } = {}) {
      commit('setLoading', true);
      return Doorphone.getMassLcdUploadJobs({ active })
        .then(({ data }) => {
          const jobs = data.jobs || [];
          if (active) {
            commit('setActiveJobs', jobs);
          } else {
            commit('setJobs', jobs);
            commit('setActiveJobs', jobs.filter(j => ['queued', 'running'].includes(j.status)));
          }
          return jobs;
        })
        .finally(() => {
          commit('setLoading', false);
        });
    },

    fetchActive ({ dispatch }) {
      return dispatch('fetchJobs', { active: true });
    },

    cancelJob ({ dispatch }, massUploadId) {
      return Doorphone.cancelMassLcdUploadJob(massUploadId)
        .then((response) => {
          return dispatch('fetchActive').then(() => response);
        });
    },

    startPolling ({ state, commit, dispatch }) {
      if (state.pollTimer) {
        return;
      }
      const tick = () => {
        dispatch('fetchActive').then((jobs) => {
          if (!jobs || jobs.length === 0) {
            dispatch('stopPolling');
          }
        }).catch(() => {});
      };
      tick();
      const timer = setInterval(tick, 7000);
      commit('setPollTimer', timer);
    },

    stopPolling ({ state, commit }) {
      if (state.pollTimer) {
        clearInterval(state.pollTimer);
        commit('setPollTimer', null);
      }
    },
  },
};
